:host {
  display: block;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
